import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Cell, HeroImageCombined } from 'sarsaparilla';
import { PassTypeProps, ReservationProps } from '../props';
import CostsTable from './CostsTable';

const propTypes = {
  passType: PassTypeProps.isRequired,
  reservation: ReservationProps.isRequired,
  children: PropTypes.node
};

export default class ReservationSummary extends PureComponent {
  static buildCosts(passType, reservation) {
    const groups = passType.groups === null ? {} : passType.groups;
    const attendees = reservation.pass_info.attendee_info;
    const costs = [{ title: 'Pass x 1', value: passType.price }];
    const total = { title: 'Total', value: passType.price };

    Object.entries(groups).forEach(([key, group]) => {
      const count = attendees[key];

      if (count === 0 || count === null || count === undefined) {
        return;
      }

      let cost;

      cost = Math.max(group.price_min, count * group.price_per_attendee);
      if (group.price_max !== 0) {
        cost = Math.min(group.price_max, cost);
      }

      costs.push({ title: `${group.name} x ${count}`, description: group.description, value: cost });
      total.value += cost;
    });

    return { costs, total };
  }

  render() {
    const { passType, reservation, children } = this.props;
    const { costs, total } = ReservationSummary.buildCosts(passType, reservation);

    return (
      <Row>
        <Cell className="parkpass-reservation-summary">
          <header>
            <HeroImageCombined id={passType.facility_id} type={'asset'} />
          </header>
          <main>
            <h4>{passType.name}</h4>
            <CostsTable lines={costs} total={total} />
          </main>
          <footer>
            {children}
          </footer>
        </Cell>
      </Row>
    );
  }
}

ReservationSummary.propTypes = propTypes;
